import { noChange } from "lit";
import { Directive, directive, PartType } from "lit/directive.js";
import { isNullable, isNumber, isString } from "sharekit";
const noAttribute = (value) => isNullable(value) || value === false;
export const updateAttribute = (el, name, value) => {
    if (noAttribute(value)) {
        el.removeAttribute(name);
    }
    else if (value === true) {
        el.setAttribute(name, "");
    }
    else if (isString(value) || (isNumber(value) && !Number.isNaN(value))) {
        el.setAttribute(name, String(value));
    }
    else {
        el[name] = value;
    }
};
class AttrDirective extends Directive {
    render(value, caller) { }
    update(part, [value, fn = updateAttribute]) {
        if (value && part.type === PartType.ELEMENT) {
            for (const name in value) {
                fn(part.element, name, value[name]);
            }
        }
        return noChange;
    }
}
/**
 * A directive that sets element attributes.
 * @param value An object with names and values.
 * @param caller A function to call for each attribute, {@link updateAttribute} by default.
 * @returns Directive to set attributes.
 */
export const attr = directive(AttrDirective);
const svgInitials = {
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
};
export const withInitials = (attrDirective, i) => (a) => attrDirective({
    ...i,
    ...a,
});
export const svgAttr = withInitials(attr, svgInitials);
//# sourceMappingURL=attr.js.map